import React from "react";
import Footer from "../Components/Common/Footer";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Layout = ({ children }) => {
  const navigate = useNavigate();
  return (
    <Box sx={{ backgroundColor: "#FEFEFE" }}>
      <Box
        sx={{
          py: 2,
          mx: 1,
        }}
      >
        <img
          src={require("../assets/images/handpik.png")}
          alt="logo"
          width={162}
          height={32}
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/")}
        />
      </Box>
      {children}
      <Footer />
    </Box>
  );
};

export default Layout;
